import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './Layout.css';
import logo from '../../assets/Full Logo Verticle.svg';
import home from '../../assets/shape.svg';
import dashboard from '../../assets/dashboard.svg';
import chat from '../../assets/chat.svg';
import help from '../../assets/help.svg';
import Logout from '../../assets/logout.svg';
import revert from '../../assets/revert.svg';
import notification from '../../assets/notifications.svg';
import { HashRouter as Router, Route, Routes,Outlet,useNavigate } from 'react-router-dom';
import DashboardList from '../dashboard/DashboardList/DashboardList';
import Popover from '@mui/material/Popover';
import OpenDashboard from '../dashboard/OpenDashboard/OpenDashboard';
import Avatar from '@mui/material/Avatar';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import NotificationsIcon from '@mui/icons-material/Notifications';
import httpClient from '../../httpClient';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import IconButton from '@mui/material/IconButton';
import Collapse  from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Chip from '@mui/material/Chip';
import Cookies from 'js-cookie';
import UsecaseList from '../usecase_list/usecase_list';
import { styled, Tooltip, TooltipProps, tooltipClasses,Badge } from '@mui/material';
import Batch from '../Batch/Batch';
import BatchWorkflow from '../BatchWorkflow/BatchWorkflow';

import { testhttpClient } from '../../httpClient';
import { toggleContainer } from '../common_utils/ui_toggle';


const Layout = () => {
  let dashboard_hover_items = false;
  let [visbleNotification,setvisbleNotification] = useState(false);
  let [notifications,setnotifications] = useState([]);
  let [notifiLoader,setnotifiLoader] = useState(false);
  const [itemsDashboardList, setItemsDashboardList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchKey,setsearchKey] = useState("");
  const [showDashboardTooltip, setShowDashboardTooltip] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [showUserTooltip,setShowUserTooltip] = useState(false)
  const [currentUser,setCurrentUser] = useState(null)
  const [currentOrg,setCurrentOrg]  = useState(null)
  const [currentUserID,setcurrentUserID]  = useState(null)
  const [clickedIcon, setClickedIcon] = useState(null);
  const [others_check,setOthersCheck] = useState(true);
  const [notificationCount, setNotificationCount] = useState(0);

  const handleIconClick = (iconName) => {
    setClickedIcon(iconName === clickedIcon ? null : iconName);
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 12,
      marginRight:'50px',
      top:'12px',
      borderRadius: '10px 0px 10px 10px',
    },
  }));

  
  
  const openDashBoardTooltip = (event) => {
    setAnchorEl(event.currentTarget);
    setShowDashboardTooltip(true);
    setSelectedButton('dashboard');
    //console.log('openssss')
    //console.log('opens')
  };

  const closeDashBoardTooltip = () => {
    setAnchorEl(null);
    setShowDashboardTooltip(false);
    setSelectedButton('');
    //console.log('leaves')
  };

  const disp_user_tooltip = (event) =>{
    setAnchorEl(event.currentTarget);
    setShowUserTooltip(true);
    setCurrentUser(localStorage.getItem('v_user_name'))
    setCurrentOrg(localStorage.getItem('v_org_name'))
    setcurrentUserID(localStorage.getItem('vector_user_id'))
    //console.log('hover works :: ')
  }



  const closeUserTooltip = () =>{
    setAnchorEl(null);
    setShowUserTooltip(false)
  }

  function refreshList() {
    try {
      const data = {
        token: localStorage.getItem('vector_token'),
        search_key: searchKey,
        page_no: 1,
        row_per_page: 100,
      };

      httpClient.post('/dream-dashboard/view', data)
        .then(response => {
          //console.log('Response:', response.data);
          setSelectedButton('home');
          const res = response.data;

          if (res.status) {
            setItemsDashboardList(res.data);
            // //console.log("dream dash :: ", itemsDashboardList);
          } else {
            //console.log(res);
          }

          //console.log("set loading off");
          setLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setLoading(false);
        });

    } catch (error) {
      setLoading(false);
      // Handle network or other errors
    }
  }

  useEffect(() => {
    refreshList();
    check_only_others_usecase();
    setCurrentUser(localStorage.getItem('v_user_name'))
    setCurrentOrg(localStorage.getItem('v_org_name'))
    setcurrentUserID(localStorage.getItem('vector_user_id'))
  }, []);

  // const ping_notifications = ()=>{
  //   let intervalId2 = setInterval(() => {
  //     getNotifications();
  //    }, 10000)
  //  }

   useEffect(() => {
    let intervalId; // Variable to hold interval ID
    let isMounted = true; // Flag to track if component is mounted

    // Function to start periodic updates
    const startPeriodicUpdates = () => {
      // Check if interval already exists
      if (!intervalId) {
        // Set interval to fetch notifications every 5 minutes (adjust as needed)
        intervalId = setInterval(() => {
          if (isMounted) {
            getNotifications();
          }
        },  10 * 1000); // 10 seconds
      }
    };

    // Start periodic updates when component mounts
    startPeriodicUpdates();

    // Cleanup function to clear interval when component unmounts
    return () => {
      isMounted = false; // Set flag to false when unmounting
      clearInterval(intervalId); // Clear the interval
    };
  }, []); // Empty dependency array ensures this effect runs only once on mount

   

  const check_only_others_usecase = ()=>{
    try {
      const data = {
        token: localStorage.getItem('vector_token'),
      }
      testhttpClient.post('/get_usecase_dashboard_map_list',data).then(response=>{
        if(response.data.status == true){
          //console.log('usecase data :: ',response.data.data)
          if(response.data.data.length==1 && response.data.data[0].usecase_id == -1){
            // console.log('dashboard list route :: ')
            navigate('/layout/DashboardList');
            setOthersCheck(true)
          }
          else{
            //console.log('usecase route ::')
            setOthersCheck(false)
            // navigate('/layout/UsecaseList')
          }
        }
        else{
          //console.log('failed response :: ',response)
        }
      }).catch(error => {
        console.error('Error:', error);
        // setLoading(false);
      });
    }catch (error) {
      //console.log('outer error :: ',error)
      // setLoading(false);
      // Handle network or other errors
    } 
  }
  
   const navigate = useNavigate();

   const logout = () => {
    localStorage.setItem('vector_token','blocked');
    Cookies.set('email','')
    Cookies.set('password','')
    navigate('/login');
   }

   const goToDashboardList = () =>{
    setSelectedButton('home');
    //console.log("\n\n\ndashboard list call")
    navigate('/layout/DashboardList');
   }

   const goToDashboard = (id) => (event) => {
    //console.log("\n\nDashboard call :: ",String(id))
    closeDashBoardTooltip();
    // Prevent the click event from propagating to the button
    event.stopPropagation();
    navigate(`/layout/Dashboard?id=${id}`);
    // navigate(`/layout/Dashboard?id=${id}`);
    // window.location.reload(false);
   }

   const goToUsecaseList = () =>{
    localStorage.removeItem('back_to_home_from_dashboard');
    navigate('/layout/UsecaseList');
   }


   const [selectedButton, setSelectedButton] = useState(null);
    
  function openNotification() {
    setvisbleNotification(true);
    getNotifications();
  }

   function closeNotification(){
    setvisbleNotification(false);
   }

   function getNotifications(){
    setnotifiLoader(true);
    try{
      const postdata = {
        token: localStorage.getItem('vector_token'),
        limit : 10
      }
      httpClient.post('/getNotificationMessages',postdata )
      .then(response => {
        setnotifiLoader(false);
        let resp = response.data;
        if(resp.status){
          setnotifications(resp.data);
          if (resp.status && resp.data !== null) {
            setNotificationCount(resp.data.length);
          } else {
            setNotificationCount(0); // Set notification count to 0 if data is null
          }
        }
      })
      .catch(error => {
        console.error('getNotificationMessages Error 1:', error);
      });
    } catch (error) {
      console.error('getNotificationMessages Error 2:', error);
    }
   }

  const [expandedItem, setExpandedItem] = useState(null);

  const handleExpand = (index) => {
    setExpandedItem(index === expandedItem ? null : index);
  };

  function markAllNotificationAsSeen(){
    let seen_mesg_id_list = [];
    for (let k = 0; k < notifications.length; k++){
      seen_mesg_id_list.push(notifications[k]["id"])
    }
    if(seen_mesg_id_list.length){
      try{
        const postdata = {
          token: localStorage.getItem('vector_token'),
          mesg_ids:seen_mesg_id_list
        }
        httpClient.post('/markNotificationAsSeen',postdata )
        .then(response => {
          setnotifiLoader(false);
          //console.log("notification marked as seen")
          setnotifications([]);
          getNotifications(); // Added here to update the notification count again
        })
        .catch(error => {
          console.error('markNotificationAsSeen Error 1:', error);
        });
      } catch (error) {
        console.error('markNotificationAsSeen Error 2:', error);
      }

    }
  }

  function markAsReadParticualrMsg(id,indx){
    try{
      const postdata = {
        token: localStorage.getItem('vector_token'),
        mesg_ids:[id]
      }
      httpClient.post('/markNotificationAsSeen',postdata )
      .then(response => {
        setnotifiLoader(false);
        let tempnotifi = [...notifications];
        tempnotifi.splice(indx,1);
        setnotifications(tempnotifi);
        getNotifications(); // to update the notification count
        //console.log("notification marked as seen");
      })
      .catch(error => {
        console.error('markNotificationAsSeen Error 11:', error);
      });
    } catch (error) {
      console.error('markNotificationAsSeen Error 22:', error);
    }
  }
  const getNextColor = (() => {
    const colorList = ["#4BB649", "#63DEF6", "#667FFF", "#66B3FF", "#8EE35B", "#B366FF", "#CA4242", "#FF6666", "#FF66B3", "#FF9966", "#FFC266", "#FFDD66"];
    let currentIndex = 0;
  
    return () => {
      const currentColor = colorList[currentIndex];
      currentIndex = (currentIndex + 1) % colorList.length; // Increment and wrap around
      return currentColor;
    };
  })();

  const selectButton = (buttonName) => {
    setSelectedButton(buttonName);
  }

  const goToBatch = () => {
    // console.log('Navigating to Batch');
    navigate('/layout/Batch');
  };


  return (
    <div className="background-container" id='background-container'>
      <div className="container1" id='container1'>
        <img id="menuleft-logo" src={logo} alt="avatar" />
        <div className='centerAlign' id='centerAlign'>
          <div className='centerElem' id='centerElem'>
            <button className={`circular-button ${selectedButton === 'home' ? 'selected' : ''}`}
                onClick={() => {
                selectButton('home');
                //console.log('others check ',others_check)
                if(others_check == false){
                  goToUsecaseList();
                }
                else{
                  goToDashboardList();
                }
                
              }} >
              <img id="home" src={home} alt="Home" />
              <div className="newTooltip">Home</div>
            </button>
          </div>

          {/* <div className='centerAlign'>
          <div className='centerElem'>
          <button className={`circular-button ${selectedButton === 'chat' ? 'selected' : ''}`}
            onClick={() => {
            goToBatch();
            selectButton('chat');
          }} >
            <img id="chat" src={chat} alt="chat" />
            <div className="newTooltip">chat</div>
          </button>
          </div>
          </div> */}


          
          <div className='centerElem' id='centerElem_1'>
         
            <button className={`circular-button ${selectedButton === 'dashboard' ? 'selected' : ''}${itemsDashboardList.length === 0 ? 'blocked' : ''}`}
              onMouseEnter={(e) => openDashBoardTooltip(e)}
              disabled={itemsDashboardList.length === 0}
              

              >
              <img id="dashboard" src={dashboard} alt="dashboard" />
              <div className="newTooltip" id='newTooltip_DB'>My Dashboard</div>
            </button>
           
            {itemsDashboardList.length > 0 && (
            <Popover 
              id="popover"
              open={showDashboardTooltip}
              onClose={closeDashBoardTooltip}
              anchorEl={anchorEl}
              anchorOrigin={{
                vertical: 'center',
                horizontal: 'right',
              }}
              transformOrigin={{
                
                vertical: 'center',
                horizontal: 'left',
              }}
              disableRestoreFocus
              onMouseLeave={closeDashBoardTooltip}
            >
              <div className='arrow-left' id='arrow-left' >
                      {itemsDashboardList.map((item, index) => (
                        <div className="each-items" key={index} onClick={goToDashboard(item.page_id)} id='each-items'>
                          <div className='ddName' id='ddName'>
                            <Tooltip title={item.page_name} arrow><div style={{backgroundColor: getNextColor(),borderRadius: '50%',width: '20px',height: '20px',display: 'inline-block',verticalAlign: 'middle',}}>
                            </div>
                            </Tooltip>
                          </div>
                          <div className='ddName' id='ddName'>
                            {item?.page_name && item.page_name.length > 25 ? (
                              <Tooltip title={item.page_name} arrow>
                                {item.page_name.slice(0, 25) + '...'}
                              </Tooltip>
                            ) : (
                              item.page_name
                            )}
                          </div>
                          
                        </div>
                      ))}
                    </div>
            </Popover>
            )}
          </div>
          
        </div>

       
        <div className="downicons" id='downicons'>
          <div className='centerElem' id='centerElem_2'>
            <button className={`circular-button ${selectedButton === 'help' ? 'selected' : ''}`}
                onClick={() => {
                selectButton('help');
                window.open('https://docs.google.com/forms/d/e/1FAIpQLSfMPGmWIMtjEEo1L0dgeOugZQ-_DbUUhfpm4FwpYhoY6VrE9Q/viewform');
              }} >
              <img id="help" src={help} alt="help" />
              <div className="newTooltip" id='newTooltip_1'>Help</div>
            </button>
          </div>
          
        
          <div className='centerElem' id='centerElem_4'>
            <button className="circular-button"onClick={logout}>
              {/* <LogoutRoundedIcon sx={{ color: blue[500] }}></LogoutRoundedIcon> */}
              <img id="Logout" src={Logout} alt="Logout" />
              <div className="newTooltip" id='newTooltip_3'>Logout</div>
            </button>
          </div>
        </div>
      </div>

      {/* container two */}
      <div className="container2" id='container2'>
        <div className='top-div' id='top-div'>
          <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={8}>
            </Grid>
            <Grid item xs={3}>
            {/* <div> */}
              <div className="top-right-icons" id='top-right-icons'>
                <Avatar className={`circular-button ${selectedButton === 'revert' ? 'selected' : ''}`}
                  onClick={toggleContainer}
                  sx={{ width: 40, height: 40 , marginLeft: '12px', backgroundColor: '#E5F6FF', color: 'E5F6FF'}}
                >
                  <Tooltip title="Revert to old UI" arrow>
                    <img id="revert" src={revert} alt="revert" />
                  </Tooltip>
                </Avatar>
                <Badge
                  badgeContent={notificationCount}
                  color="error"
                  overlap="circular"
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  >
                <Avatar className={`circular-button ${selectedButton === 'revert' ? 'selected' : ''}`}
                  onClick={openNotification}
                  sx={{ width: 40, height: 40 , marginLeft: '12px', backgroundColor: '#E5F6FF', color: '#00AAFF'}}
                >
                 <Tooltip title="Notification" arrow>
                    <img id="notification" src={notification} alt="notification" />
                  </Tooltip>
                </Avatar>
                </Badge>
                  <LightTooltip title={
    <div id="profile_1" style={{ display: 'flex', alignItems: 'center', padding: '8px' }}onMouseEnter={(e) => disp_user_tooltip(e)}>
      <div id="profile_2" style={{ borderRadius: '50%', backgroundColor: '#E5F6FF', padding: '4px', marginRight: '8px' }}>
        <PersonOutlineOutlinedIcon style={{ fontSize: '24px', color: '#00AAFF' }} />
      </div>    
      <div id="profile_3">
        {currentUser}
        <br />
        {currentOrg}
      </div>
    </div>
  }>
    <Avatar
      sx={{
        width: 39,
        height: 39,
        backgroundColor: '#E5F6FF',
        color: '#00AAFF',
        marginLeft:'12px'
      }}
    >
      <PersonOutlineOutlinedIcon />
    </Avatar>
  </LightTooltip>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className='child-container'>
          <Outlet />
        </div>
        
        <Routes>
          <Route path="DashboardList" element={<DashboardList />} />
          <Route path="Dashboard" element={<OpenDashboard />} />
          <Route path="UsecaseList" element={<UsecaseList />} />
          <Route path="Batch" element={<Batch />} />
          <Route path="BatchWorkflow" element={<BatchWorkflow />} />
        </Routes> 
      </div>
      <Modal open={visbleNotification} onClose={closeNotification} slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0, 0, 0, 0.5)' } } }}>
        <Box
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            bottom: 10,
            width: 400,
            borderRadius: '15px',
            backgroundColor: 'white',
            padding: 2,
          }}
        >
          <div className='notiheader' id='notificationTitle'>
            <NotificationsIcon sx={{color:'#00AAFF',height:25,width:30}}/>
            <span className='notihead'>Notifications</span>
          </div>
          <div style={{textAlign:'right',height:'40px'}} id='noti_1'>
            <Button onClick={markAllNotificationAsSeen} size='small' sx={{backgroundColor:'#00AAFF',color:'white','&:hover': {
                                    backgroundColor: 'white', // Adjust the alpha value to control transparency
                                    color: '#00AAFF',
                                    border:'1px solid #00AAFF'
                                }}}>Mark as Read</Button>
          </div>
          <div className='msgList'>
            <List>
              {notifications.slice(-10).map((item, Itindex) => (
                <React.Fragment key={Itindex}>
                  <ListItem sx={{backgroundColor: '#E5F6FF',boxShadow: '0px 0px 2px 0px #00000033',padding:'10px',marginBottom:'5px',borderRadius:'15px'}}>
                    <IconButton onClick={()=>markAsReadParticualrMsg(item.id,Itindex)} style={{ position: 'absolute', top: 0, right: 0 }}>
                      <CloseIcon />
                    </IconButton>
                    <ListItemText
                      primary={
                        <div style={{width:'350px', whiteSpace: 'pre-wrap',lineHeight: '1'}} >
                         {(item.text.length > 50 && Itindex !== expandedItem) ? `${item.text.slice(0, 50)}...` : item.text}
                        </div>
                      }
                      secondary={
                        <>
                        {item.date}
                        {item.text.length > 50 && (
                        <IconButton onClick={() => handleExpand(Itindex)}>
                          {(Itindex !== expandedItem)?(<ExpandMoreIcon />) : (<ExpandLessIcon />)}
                        </IconButton>
                        )}
                        </>
                        }
                      />
                  </ListItem>
                </React.Fragment>
              ))}
            </List>
          </div>
        </Box>
      </Modal>
    </div>
  );
};




Layout.propTypes = {};

Layout.defaultProps = {};

export default Layout;